import React from 'react';
import PropTypes from 'prop-types';
import TableItem from './TableItem';

const TableItems = ({ list_mc, tableItems, tableHeads, editEnabled }) => {
    // Verifica si tableItems es un array
  if (!Array.isArray(tableItems)) {
    console.error('tableItems debe ser un array');
    return null; // O cualquier otro manejo de error que desees
  }
  const allTableItems = tableItems.map(tableItem => (
    <TableItem key={tableItem.id} tableItem={tableItem} tableHeads={tableHeads} editEnabled={editEnabled} list_mc={list_mc} />
  ));

  return <tbody>{allTableItems}</tbody>;
};

TableItems.propTypes = {
  tableItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  tableHeads: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleEditFormOpen: PropTypes.func,
};

TableItems.defaultProps = {
  tableItems: [
    {
      id: 1,
      iteM_PARTIDA: {
        cantidadPreviaServicio: 0,
        cantidadTotalServicio: 224000,
        clasePartidaId: 2,
        clasePartidaTitle: "C2 Servicios pagados a precios unitarios",
        claseTipoPartidaId: 1,
        codigoContrato: "6700295323B",
        codigoPartida: "10",
        elementId: 12,
        gastoPrevioBasePartida: 0,
        gastoPrevioDiftcPartidaMc: 0,
        gastoPrevioReajustePartida: 0,
        id: 1,
        idMcContrato: 0,
        idMonedaContrato: 16,
        idMonedaPartida: 16,
        l_polinomios: [],
        mcNombre: "0",
        mesInicioPartida: "2016/09",
        mesPrevio: "0000/00",
        mesTerminoPartida: "2018/12",
        monedaContrato: "CLP",
        monedaPartida: "CLP",
        montoTotalPartida: 425600000,
        montoTotalSumaAlzadaPartida: 0,
        nombrePartida: "Desayuno",
        nroPartida: 1,
        precioUnitarioBasePartida: 1900,
        tipoPartidaId: 1,
        tipoPartidaTitle: "Alimentación",
        unidadPartidaId: 1,
        unidadPartidaTitle: "c/u",
      },
      l_POLINOMIO: [{
        fechaBase: null,
        id: 0,
        mesesDesfase: null,
        partidaId:  0,
        periodicidadMeses: null,
        ponderador:  null,
        primerMesReajuste: null,
        subpartidaId: null,
        tipoPolinomioId: 0,
        valorBase: null,
      }],
      l_SUBPARTIDA: []
    },
  ],
};

export default TableItems;
